<app-popup-layout #modal>
  <header class="modal-header">
    <app-close-button class="ms-auto" (onCloseEmitter)="modal.dismiss()"></app-close-button>
  </header>
  <div class="modal-container">
    <img src="assets/home/e-rupi-voucher-image.svg" class="meal-card-contact" alt="eRupi Voucher" />
    <section class="d-flex flex-column">
      <section style="padding-top: 15px" class="align-items-center d-flex flex-column justify-center mx-24 info">
        <p class="title mb-8">
          Thank you for showing interest in “eRupi Voucher with EnKash.
        </p>
        <p class="sub-title mb-8">
          EnKash team will reach out to you shortly for the eRupi Voucher
          automation setup
        </p>

        <p class="sub-title mb-16">
          To expedite your inquiry, write to us at
          <a class="email-link" [href]="'mailto:' + 'sales@enkash.com'" target="_top">sales&#64;enkash.com</a>
        </p>

        <button mat-flat-button color="primary" class="custom-button-submit" (click)="modal.dismiss()">
          Okay
        </button>
      </section>
      <img src="assets/home/meal-card-footer-design.png" class="footer-design mt-auto" alt="eRupi Voucher Footer" />
    </section>
  </div>
</app-popup-layout>